import React, { useState } from "react";
import { MessageTypes } from "./messageTypes";
import apiService from "services/apiService";
import MessageBubble from "./MessageBubble";



const CloseIcon = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    className="w-6 h-6 text-gray-600 hover:text-red-500 cursor-pointer"
    fill="none"
    viewBox="0 0 24 24"
    stroke="currentColor"
  >
    <line x1="18" y1="6" x2="6" y2="18" strokeWidth="2" />
    <line x1="6" y1="6" x2="18" y2="18" strokeWidth="2" />
  </svg>
);

 interface ChatComponentProps {
  onClose: () => void
}

const ChatComponent = ({onClose}:ChatComponentProps) => {
  const [messages, setMessages] = useState<MessageTypes[]>([
    {
      id: 1,
      message: "Hi, how can I help you today?",
      sender: "bot",
    },
  ]);
  const [loading, setLoading] = useState(false);

  const [input, setInput] = useState("");

  const sendMessage = () => {
    if (loading) return;
    const inputMessage = input.trim();
    if (!inputMessage) return;
    setLoading(true);

    const userMessage: MessageTypes = {
      id: Date.now(),
      message: inputMessage,
      sender: "user",
    };

    setMessages((prev) => [...prev, userMessage]);
    setInput("");

    apiService.post("api/chat/ask", {
        question:inputMessage
    }).then((response) => {
        console.log("Chat bot response",response)
        console.log("Response data : ",response.data);
        // if(response.status === 2000){
            const botMessage: MessageTypes = {
                id: Date.now() + 1,
                message: response.data,
                sender: "bot",
            }
            setMessages((pre) => [...pre, botMessage])
        // }
    }).catch(error => {
        console.log(error)
    }).finally(()=>{
      setLoading(false)
    })
  };

  return (
    <div className="fixed bottom-24 right-4 w-[380px] h-[520px] bg-white dark:bg-gray-800 dark:text-white border dark:border-gray-700 shadow-xl rounded-lg flex flex-col z-[10000]">

      {/* Header */}
      <div className="p-4 border-b dark:border-gray-700 flex flex-row items-center justify-between">
        <section>
            {/* <img src={LogoIMage} alt="liri-logo" width={40} height={40}></img> */}
            <svg
                    viewBox="0 0 64 74"
                    className="w-6 h-6"
                    aria-hidden="true"
                    focusable="false"
                  >
                    <path
                      d="M10 8c0-3.3 2.7-6 6-6h8v44h18c3.3 0 6 2.7 6 6v6H16c-3.3 0-6-2.7-6-6V8z"
                      fill="#2563EB"
                    />
                    <rect x="28" y="12" width="14" height="14" rx="4" fill="#2563EB" />
                    <rect x="44" y="12" width="14" height="14" rx="4" fill="#2563EB" />
                    <rect x="28" y="28" width="14" height="14" rx="4" fill="#2563EB" />
                    <path d="M44 28h8l6 6v8h-8a6 6 0 0 1-6-6v-8z" fill="#2563EB" />
                  </svg>
        </section>
        <section>
            <h2 className="font-semibold text-lg">Liri Assistant</h2>
        </section>
        <section>
          <button onClick={onClose}>
            <CloseIcon></CloseIcon>
          </button>
        </section> 
      </div>
      {/* Messages */}
      <MessageBubble messages={messages} isLoading={loading}/>

      {/* Input */}
      <div className="p-3 border-t flex gap-2">

        <input
          value={input}
          onChange={(e) => setInput(e.target.value)}
          placeholder="Type your message..."
          className="flex-1 border rounded-md px-3 py-2 text-sm dark:bg-gray-700 dark:text-white dark:focus:outline-none dark:focus:ring-2 dark:focus:ring-gray-400"
          onKeyDown={(e) => {
            if (e.key === "Enter") {
              e.preventDefault();
              if (!loading) {
                sendMessage();
              }
            }
          }}
        />

        <button
          onClick={sendMessage}
          className={`bg-blue-700 dark:bg-blue-600 text-white px-4 py-2 rounded-md text-sm hover:bg-blue-800 ${loading ? "cursor-not-allowed bg-gray-300" : ""}`}
          disabled={loading}
        >
          Send
        </button>

      </div>
    </div>
  );
};

export default ChatComponent;